import { render, staticRenderFns } from "./MenuNotification.vue?vue&type=template&id=7e002846&scoped=true&"
var script = {}
import style0 from "./MenuNotification.vue?vue&type=style&index=0&id=7e002846&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e002846",
  null
  
)

export default component.exports